export const path = {
  myDoctors: {
    route: "/my-doctors",
    link: () => path.myDoctors.route,
  },
};
